import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/components/auth/Login.vue'
import ProjectLogin from '@/components/auth/ProjectLogin.vue'
import Logout from '@/components/auth/Logout.vue'
// import Home from '@/views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: ProjectLogin,
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/staff/login',
    name: 'staff_login',
    component: Login,
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
    // meta: {
    //   requiresAuth: true,
    // }
  },
  {
    path: '/',
    redirect: '/login',
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/school/list',
    name: 'SchoolList',
    component: () => import('@/views/SchoolList.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/parameter/list',
    name: 'ParameterList',
    component: () => import('@/views/ParameterList.vue'),
    meta: {
      requiresAuth: true,
    }
  },  
  {
    path: '/enrolmentprojection/list',
    name: 'EnrolmentProjectionList',
    component: () => import('@/views/EnrolmentProjectionList.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/project/create',
    name: 'ProjectCreate',
    component: () => import('@/views/ProjectCreate.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/project/list',
    name: 'ProjectList',
    component: () => import('@/views/ProjectList.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/project/:id',
    name: 'ProjectSubmit',
    component: () => import('@/views/ProjectSubmit.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/project/:id/edit',
    name: 'ProjectEdit',
    component: () => import('@/views/ProjectEdit.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
]

export default routes
